<template>
  <section class="section-base form-section-base">
    <div class="form-section-base__title">
      Сведения о доверенности в машиночитаемом виде
    </div>

    <v-container>
      <div class="form-base">
        <MrpaUploader
          :v="$v"
          :statement-id="$route.params.statementId"
          :statement-type="StatementType.EGRN_CONFIRM"
          @parsed-mrpa-change="parsedMrpaChangeHandler"
          is-participant
        />

        <MachinePerson v-if="formVisible" :v="$v.applicant.person" />

        <Footer
          @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
          @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
          :loading-next="loadingNext"
        />
      </div>
    </v-container>
  </section>
</template>

<script>
import { mdiAlertCircleOutline } from '@mdi/js';
import { leaveStep, checkInvalid } from '@/utils/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import { getValidationErrorText } from '@/utils/validate';
import cloneDeep from 'clone-deep';
import { ServicesModule } from '@/store/modules/services';
import deepmerge from 'deepmerge';
import { MrpaType, StatementType } from '@/constants';
import MrpaUploader, {
  getMrpa,
  mrpaUploaderModel,
  mrpaUploaderValidation,
  prefillMrpDisabled,
} from '@/components/services/elements/MrpaUploader';
import MachinePerson, {
  machinePersonModel,
  getMachinePersonValidation,
} from './MachinePerson';
import { MrpaSubjectModule } from '@/store/modules/mrpaSubject';
import {
  assemblyMrpaTrustee,
  getDefaultMachineTrustee,
} from '@/components/services/elements/MrpaTrustee';

const getDefaultForm = () => ({
  person: cloneDeep(machinePersonModel),
});

export default {
  name: 'Machine',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    MachinePerson,
    Footer,
    MrpaUploader,
  },
  data() {
    return {
      StatementType,
      mdiAlertCircleOutline,
      getValidationErrorText,
      mrpa: cloneDeep(mrpaUploaderModel.mrpa),
      formVisible: mrpaUploaderModel.formVisible,
      applicant: getDefaultForm(),
      StepDirection,
      StepName,
      leaveStep,
      invalidFields: [],
    };
  },
  validations() {
    return {
      ...mrpaUploaderValidation,
      applicant: {
        person: getMachinePersonValidation(this.applicant.person),
      },
    };
  },
  created() {
    const applicantStore = cloneDeep(
      ServicesModule.statement.subjects.applicantRightholder
    );

    if (applicantStore?.trustee) {
      this.prefillDraft(applicantStore, false);
    }
  },
  methods: {
    prefillDraft(applicant, isMrpa) {
      if (isMrpa) {
        prefillMrpDisabled(applicant);
      }

      if (applicant.person) {
        this.applicant.person = deepmerge.all([
          machinePersonModel,
          applicant.person,
          {
            trustee: getDefaultMachineTrustee(applicant.trustee),
          },
        ]);
      }

      this.mrpa = getMrpa(applicant);
      this.formVisible = true;
    },

    assemblyModel() {
      const applicantEntity = cloneDeep(this.applicant);
      const trustee = applicantEntity.person.trustee;

      delete applicantEntity.person.trustee;

      return {
        person: applicantEntity.person,
        mrpType: this.mrpa.type,
        trustee: assemblyMrpaTrustee({
          trustee,
          mrpa: this.mrpa,
        }),
      };
    },

    async touchFields() {
      this.invalidFields = [];

      this.$v.formVisible.$touch();

      if (this.$v.formVisible.$invalid) {
        checkInvalid(this.$v.formVisible, this.invalidFields);
        return;
      }

      this.$v.applicant.person.$touch();
      checkInvalid(this.$v.applicant.person, this.invalidFields);

      if (this.invalidFields.length === 0) {
        if (this.mrpa.type === MrpaType.BY_GUID) {
          const isMrpaValid = await this.checkMrpaGuid();

          if (!isMrpaValid) this.invalidFields.push(true);
        }
      }
    },

    parsedMrpaChangeHandler(parsedMrpa) {
      if (parsedMrpa) {
        this.prefillDraft(parsedMrpa, true);
        this.formVisible = true;
      } else {
        this.applicant = getDefaultForm();
        this.formVisible = null;
      }
    },

    async checkMrpaGuid() {
      try {
        await MrpaSubjectModule.checkMrpaParticipantGuid({
          statementId: this.$route.params.statementId,
          guid: this.mrpa.guid,
          issuerInn: this.mrpa.issuerInn,
        });

        return true;
      } catch (e) {
        return false;
      }
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: StepName.S4,
      });
    },
  },
};
</script>
